export default __webpack_public_path__ + "static/media/banner.c3ae9dde.jpg";